import { render, staticRenderFns } from "./Couriers.vue?vue&type=template&id=4949eb82&scoped=true"
import script from "./Couriers.vue?vue&type=script&lang=js"
export * from "./Couriers.vue?vue&type=script&lang=js"
import style0 from "./Couriers.vue?vue&type=style&index=0&id=4949eb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949eb82",
  null
  
)

export default component.exports